/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectTaskCreateDto } from '../../models/core-project-task-create-dto';
import { CoreProjectTaskResponseDto } from '../../models/core-project-task-response-dto';

export interface ProjectTasksControllerCreate$Params {

/**
 * The tenant identifier.
 */
  tenant: string;
      body: CoreProjectTaskCreateDto
}

export function projectTasksControllerCreate(http: HttpClient, rootUrl: string, params: ProjectTasksControllerCreate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectTaskResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, projectTasksControllerCreate.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreProjectTaskResponseDto>;
    })
  );
}

projectTasksControllerCreate.PATH = '/o2-core/project-tasks/{tenant}';
